<template>
  <div class="py-5 cs-home-benefits">
    <b-container>
      <b-row class="pb-3 text-center text-lg-left">
        <b-col>
          <span class="cs-home-benefits-title">{{ content.title }}</span>
        </b-col>
      </b-row>
      <div v-for="(benefit, idx) in content.benefits" v-bind:key="benefit._id">
        <b-row class="py-lg-5 py-3">
          <b-col>
            <span class="cs-home-benefits-item-title">{{ idx+1 }}) {{ benefit.title }}</span>
          </b-col>
        </b-row>
        <b-row class="text-justify">
          <b-col>
            <span class="cs-home-benefits-item-description">{{ benefit.description }}</span>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'SectionBenefits',
  props: {
    content: Object,
  },
};
</script>

<style scoped lang="scss">
.cs-home-benefits {
  color: $brandSecondaryColor;
}

.cs-home-benefits-title {
  font-size: $homeSectionTitle;
  font-weight: bold;
}

.cs-home-benefits-item-title {
  font-size: $homeSectionItemTitle;
  font-weight: $brandTitleWeight;
}

.cs-home-benefits-item-description {
  font-size: $homeSectionItemDescription;
  font-weight: $brandSubTitleWeight;
}

@media (max-width: 1000px) {
  .cs-home-benefits-title {
    font-size: $homeSectionTitle;
  }
  .cs-home-benefits-item-title {
    font-size: $homeSectionItemTitle;
  }
  .cs-home-benefits-item-description {
    font-size: $homeSectionItemDescription;
  }
}

@media (max-width: 800px) {
  .cs-home-benefits-title {
    font-size: $homeSectionTitle+1.5;
  }
  .cs-home-benefits-item-title {
    font-size: $homeSectionItemTitle+1;
  }
  .cs-home-benefits-item-description {
    font-size: $homeSectionItemDescription+1;
  }
}

@media (max-width: 600px) {
  .cs-home-benefits-title {
    font-size: $homeSectionTitle+2;
  }
  .cs-home-benefits-item-title {
    font-size: $homeSectionItemTitle+2;
  }
  .cs-home-benefits-item-description {
    font-size: $homeSectionItemDescription+2;
  }
}

@media (max-width: 400px) {
  .cs-home-benefits-title {
    font-size: $homeSectionTitle+3.5;
  }
  .cs-home-benefits-item-title {
    font-size: $homeSectionItemTitle+3.5;
  }
  .cs-home-benefits-item-description {
    font-size: $homeSectionItemDescription+3.5;
  }
}
</style>
